<section [style.background-color]="this.gameConfig.headerColor" *ngIf="this.mod == true">
  <div class="container px-0" >
    <nav class="navbar navbar-expand-lg custom-navbar">
      <div class="container-fluid">
        <a class="navbar-brand">
          <h1 *ngIf="!portalName?.includes('.png')">{{portalName}}</h1>
          <img *ngIf="portalName?.includes('.png')" src='{{portalName}}' alt="card1">
        </a>
        <div class="d-flex">
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12">
              <path id="Path_39032" data-name="Path 39032"
                d="M4,18H20a1,1,0,0,0,0-2H4a1,1,0,0,0,0,2Zm0-5H20a1,1,0,0,0,0-2H4a1,1,0,0,0,0,2ZM3,7A1,1,0,0,0,4,8H20a1,1,0,0,0,0-2H4A1,1,0,0,0,3,7Z"
                transform="translate(-3 -6)" fill="#fff" />
            </svg>
          </button>
          <!-- <div class="btn btn-link px-0 d-block d-lg-none">
            <div class="search-container">
              <form action="/search" method="get">
                <input class="search expandright" id="searchright" type="search" name="q" placeholder="Search">
                <label class="btn searchbutton" for="searchright"><span class="mglass">&#9906;</span></label>
              </form>
            </div>
          </div> -->
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center myclass">
            <li class="nav-item" *ngIf="configNav?.home != ''">
              <a class="nav-link  cursorProperty" aria-current="page" routerLinkActive="active" [routerLink]="['/home']" [queryParams]="queryParam" queryParamsHandling= 'preserve'>{{configNav.home}}</a>
            </li>
            <li class="nav-item" *ngIf="configNav.about != ''">
              <a class="nav-link" aria-current="page" routerLinkActive="active" [routerLink]="['/about']" [queryParams]="queryParam" queryParamsHandling= 'preserve'>{{configNav.about}}</a>
            </li>
            <li class="nav-item" *ngIf="configNav.account != '' && queryParam.id != '415'">
              <a class="nav-link" [routerLink]="['/account']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>{{configNav.account}}</a>
            </li>
            <li class="nav-item" *ngIf="configNav.tc != '' && queryParam.id != '16'">
              <a class="nav-link" [routerLink]="['/tc']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>{{configNav.tc}}</a>
            </li>
            <li class="nav-item" *ngIf="configNav.faq != '' && queryParam.id != '16' && queryParam.id != '543' && queryParam.id != '544'">
              <a class="nav-link" [routerLink]="['/faq']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>{{configNav.faq}}</a>
            </li>
            <li class="nav-item" *ngIf="configNav.faq != '' && queryParam.id != '16' && (queryParam.id == '543' || queryParam.id == '544')">
              <a class="nav-link" [routerLink]="['/new-faq']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>{{configNav.faq}}</a>
            </li>
            <li class="nav-item" *ngIf="queryParam.id == '16'">
              <a class="nav-link" [routerLink]="['/adventure']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>Adventure</a>
            </li>
            <li class="nav-item" *ngIf="queryParam.id == '16'">
              <a class="nav-link" [routerLink]="['/arcade']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>Arcade</a>
            </li>
            <li class="nav-item" *ngIf="queryParam.id == '16'">
              <a class="nav-link" [routerLink]="['/plg']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'>Puzzle and Logic Games</a>
            </li>
            <li class="nav-item d-none d-lg-block">
              <!-- <div class="search-container">
                <form action="/search" method="get">
                  <input class="search expandright" id="search" type="search" name="q" placeholder="Search">
                  <label class="btn searchbutton" for="search"><span class="mglass">&#9906;</span></label>
                </form>
              </div> -->
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</section>

<router-outlet>

</router-outlet>

<footer class="mt-5" [style.background-color]="this.gameConfig.footerColor" *ngIf="gameConfig.footer != null">
  <div class="container position-relative" *ngIf="queryParam.id == '16'">
    <a [routerLink]="['/tc']" routerLinkActive="active" [queryParams]="queryParam" queryParamsHandling= 'preserve'><h3 class="tc" style="font-size: 16px;color: var(--secondry-color);
      ">Terms & Conditions</h3></a>
  </div>
  <div class="container position-relative">
      {{gameConfig.footer}}
  </div>
 
</footer>
